module.exports = __webpack_public_path__ + "static/tangled-4_ceramic-mixed-media-private-collection-e7690a7403cc4b126dd9e16d43b14de6.jpg";